module.exports = __webpack_public_path__ + "static/img/zhogyiyao.2b38f51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhogyiyao.png
// module id = 3CmK
// module chunks = 1